import { render } from "./TourName.vue?vue&type=template&id=bc06d88e"
import script from "./TourName.vue?vue&type=script&lang=js"
export * from "./TourName.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bc06d88e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc06d88e', script)) {
    api.reload('bc06d88e', script)
  }
  
  module.hot.accept("./TourName.vue?vue&type=template&id=bc06d88e", () => {
    api.rerender('bc06d88e', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CreateTourFormParts/TourName.vue"

export default script